import { render, staticRenderFns } from "./AppUpgrade.vue?vue&type=template&id=61886f63&scoped=true"
import script from "./AppUpgrade.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppUpgrade.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_n4a2vfauuuf6vmcvyn2rbj6bo4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61886f63",
  null
  
)

export default component.exports